import { ComponentProps } from 'react'

import { Breadcrumbs as MuiBreadcrumb, styled } from '@mui/material'

export type BreadcrumbsProps = Omit<ComponentProps<typeof MuiBreadcrumb>, 'separator'> & {
  children: React.ReactNode
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ children, ...props }) => (
  <StyledBreadcrumbs separator=">" aria-label="breadcrumb" {...props}>
    {children}
  </StyledBreadcrumbs>
)

const StyledBreadcrumbs = styled(MuiBreadcrumb)`
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  color: ${({ theme }) => theme.palette.text.secondary};
  text-decoration: none !important;
`